import { render, staticRenderFns } from "./FlexiquoteModuleListView.vue?vue&type=template&id=84a70a1e"
import script from "./FlexiquoteModuleListView.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a70a1e')) {
      api.createRecord('84a70a1e', component.options)
    } else {
      api.reload('84a70a1e', component.options)
    }
    module.hot.accept("./FlexiquoteModuleListView.vue?vue&type=template&id=84a70a1e", function () {
      api.rerender('84a70a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/flexiquotemodule/FlexiquoteModuleListView.vue"
export default component.exports